<template>
  <PageBase title="Projectgegevens" description="" :valid="valid" @show-error="showError" :show-right-button="true" :show-left-button="true">

    <div class="text-sm">In onderstaande velden kunt u de gegevens van de uw project, het programma en type opgave
      invoeren.</div>

    <div class="text-sm">Selecteer de waarden die voor uw school van toepassing zijn:</div>

    <div class="flex gap-1 mt-2">
      <label
        class="text-sm mt-1 flex-1/6"
      >
        Projectnaam:
      </label>
      <div class="flex-5/6">
        <input class="rounded-sm p-1 pl-3 text-sm w-full"
        :class="!store.registrationData.naam && errorsShown && isFieldInError(store.registrationData.naam) ? 'border-red-400 border-2' : 'border-slate-300 border'"
        type="text"
        v-model="store.registrationData.naam"
        />
      </div>
    </div>

    <div class="flex gap-1">
      <label
        class="text-sm mt-1 flex-1/6"
      >
        Adres:
      </label>
      <div class="flex-5/6">
        <input class="rounded-sm p-1 pl-3 text-sm w-full"
         :class="!store.registrationData.adres && errorsShown && isFieldInError(store.registrationData.adres) ? 'border-red-400 border-2' : 'border-slate-300 border'"
        type="text"
        name="Address"
        v-model="store.registrationData.adres"
        />
      </div>
    </div>

    <div class="flex gap-1">
      <label
        class="text-sm mt-1 flex-1/6"
      >
        Plaats:
      </label>
      <div class="flex-5/6">
        <input class="rounded-sm p-1 pl-3 text-sm w-full"
         :class="!store.registrationData.plaats && errorsShown && isFieldInError(store.registrationData.plaats) ? 'border-red-400 border-2' : 'border-slate-300 border'"
        type="text"
        name="City"
        v-model="store.registrationData.plaats"
        />
      </div>
    </div>

    <div class="flex flex-col gap-6 mt-3">
      <div class="flex">
        <label
          class="text-sm mt-1 flex-1/6"
        >
          Schooltype:
        </label>
        <div class="flex flex-col flex-5/6 gap-2 px-4 py-1 -ml-5" :class="!store.registrationData.opgave && errorsShown && isFieldInError(store.registrationData.schoolType) && 'border-red-400 border-2'">
          <div v-for="option in radioOptions" :key="option.name" class="flex gap-2">
            <input
              :id="option.value"
              aria-describedby="candidates-description"
              name="candidates"
              type="radio"
              class="focus:ring-pohvBlue h-5 w-5 text-primary border-gray-300 rounded-lg"
              :value="option.value"
              v-model="store.registrationData.schoolType"
              selected
              @change="schoolTypeChanged"
            />
            <label
              class="text-sm ml-1.5 flex-1/6"
              :for="option.value"
            >
              {{ option.name }}
            </label>
          </div>
        </div>
      </div>

      <div v-if="store.registrationData.schoolType" class="flex -mt-4">
        <label
          class="flex-1/6"
        ></label>
        <div class="flex flex-col flex-5/6 gap-2 border-t border-t-slate-300 pt-6">
          <div class="flex flex-col flex-5/6 gap-2">
            <div v-for="option in options" :key="option.name" class="flex mt-1 gap-2">
              <input
                :id="option.value"
                aria-describedby="candidates-description"
                name="candidates"
                type="checkbox"
                class="focus:ring-pohvBlue h-5 w-5 text-primary border-gray-300 rounded-lg"
                :value="option.value"
                v-model="store.registrationData.schoolTypeAdditional"
              />
              <label
                class="text-sm ml-1.5 flex-1/6"
                :for="option.value"
              >
                {{ option.name }}
              </label>
            </div>
          </div>
        </div>
      </div>


      <div class="flex">
        <label
          class="text-sm mt-1 flex-1/6"
        >
          Opgave:
        </label>
        <div class="flex-5/6 flex flex-col gap-2 px-4 py-2 -ml-5" :class="errorsShown && isFieldInError(store.registrationData.opgave) && 'border-red-400 border-2'">
            <div v-for="option in opgaveOptions" :key="option" class="flex gap-2">
              <input
                :id="option"
                name="opgave"
                type="radio"
                class="focus:ring-pohvBlue h-5 w-5 text-primary border-gray-300 rounded-lg"
                :value="option"
                v-model="store.registrationData.opgave"
                selected
              />
              <label
                class="text-sm ml-1.5 flex-1/6"
                :for="option"
              >
                {{ option }}
              </label>
          </div>

        </div>
      </div>

      <div class="italic text-sm mb-5">Deze gegevens worden gebruikt om het Programma van Eisen af te stemmen op uw opgave.</div>
    </div>
  </PageBase>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import PageBase from '@/views/pages/PageBase.vue';
import { useRegistrationStore } from '@/stores/registration'

const store = useRegistrationStore()
const POOptions = ref([{ name: 'Buiten Schoolse Opvang (BSO)', value: 'BSO' },
{ name: 'Kinderdagverblijf (KDV)', value: 'KDV' }, { name:'Sport', value: 'Sport' }])
const VOOptions = ref([{ name:'Sport', value: 'Sport' }])
const radioOptions = ref([{ name: 'Primair Onderwijs (PO)', value: 'PO' }, { name: 'Voortgezet Onderwijs (VO)', value: 'VO' }])
const opgaveOptions = ref(['Renovatie', 'Nieuwbouw'])

const valid = computed(() => {
  return store.registrationData.opgave.length > 0 && store.registrationData.schoolType.length > 0 && store.registrationData.naam.length > 0 && store.registrationData.adres.length > 0 && store.registrationData.plaats.length > 0
})
const options = computed(() => {
  return store.registrationData.schoolType == 'PO' ? POOptions.value : VOOptions.value
})

const errorsShown = ref(false)

function showError() {
  errorsShown.value = true
}

function isFieldInError(field: string) {
  return !field || field.length <= 0
}

function schoolTypeChanged() {
  if (store.registrationData.schoolType != 'PO') {
    if (store.registrationData.schoolTypeAdditional.includes('BSO')) {
      store.registrationData.schoolTypeAdditional.splice(store.registrationData.schoolTypeAdditional.indexOf('BSO'), 1)
    }

    if (store.registrationData.schoolTypeAdditional.includes('KDV')) {
      store.registrationData.schoolTypeAdditional.splice(store.registrationData.schoolTypeAdditional.indexOf('KDV'), 1)
    }
  }
}

</script>
